/**
 * Password policy: min 10 chars; at least one upper, one lower, one digit, one special.
 * Returns null if valid, or an error message string.
 */
export function validatePassword(password) {
  if (!password || typeof password !== 'string') return 'Password is required';
  if (password.length < 10) return 'Password must be at least 10 characters';
  if (!/[A-Z]/.test(password)) return 'Password must include at least one uppercase letter';
  if (!/[a-z]/.test(password)) return 'Password must include at least one lowercase letter';
  if (!/[0-9]/.test(password)) return 'Password must include at least one number';
  if (!/[^A-Za-z0-9]/.test(password)) return 'Password must include at least one special character (e.g. !@#$%^&*)';
  return null;
}

export const PASSWORD_HINT = 'At least 10 characters; include one uppercase, one lowercase, one number, and one special character (e.g. !@#$%^&*)';
